import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  Table,
  TableContainer,
  TableCell,
  TextField,
  TableHead,
  TableRow,
  TableBody,
  Tooltip,
  Paper,
  IconButton,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material'
import { AddOutlined as AddOutlinedIcon } from '@mui/icons-material'
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined'

import {
  ACTIVITY_TYPES,
  CURRENCY_COUNTRY_CODE,
  DROPDOWN_DEFAULT_VALUE,
  EXCEL_COLUMNS,
  FIELD_TYPES,
  REDIRECT_TIMER,
  TOAST_SETTINGS,
  TOAST_SETTINGS_ERROR,
} from '../../utility/constants'
import {
  getProcessDashboardReportData,
  getProcessStatusByReferenceNum,
} from '../../utility/dataEntry/formData'
import ProcessDashboardValues from '../../components/Dashboard/ProcessDashboardValues'
import { intersection } from '../../utility/utilityFunctions'
import ConfirmationBox from '../../components/Dashboard/ConfirmationBox'
import moment from 'moment'
import { containsKeys } from '../DataEntryPage/utils/filterUtils'
import { getFieldId } from '../DataEntryPage/utils/utils'
import { downloadExcel } from '../../utility/excelDownloadUtils'
import TableSetting from '../../components/Dashboard/PreviewComponent/TableSettings/TableSetting'
import { getColumnForSetting, getFieldForSetting } from '../DataEntryPage/utils/fieldUtil'
import { userConfig } from '../../services/userConfigServices'
import DateRangePickerComponent from '../../components/Dashboard/DateRangePickerComponent'
import DateTimeRangePickerComponent from '../../components/Dashboard/DateTimeRangePickerComponent'
import NumberRangeComponent from '../../components/Dashboard/NumberRange'
import ListDropdown from '../../components/Dashboard/ListRange'
import CurrencyRangeComponent from '../../components/Dashboard/CurrencyRangeComponent'
import ClearableTextField from '../../components/Dashboard/ClearableTextField'
import { useResponsiveTypography } from '../../utility/responsiveTypography'
export default function ProcessDashboard() {
  const searchTimer = useRef()
  const { user } = useAuthContext()
  const navigate = useNavigate()
  const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL
  const confirmationText = 'Are you sure you want to create a new process workflow?'
  let axiosOptions = {}
  if (user) {
    axiosOptions = {
      headers: { Authorization: `Bearer ${user.token}` },
    }
  }
  const [processDashBoardData, setProcessDashBoardData] = useState({
    processTemplate: {},
    processData: [],
    fieldTemplatesAll: [],
    fieldTemplates: [],
    hiddenColumns: [],
    activityTemplatesAll: [],
    activityTemplates: [],
    hiddenActivityColumns: [],
  })
  const [filteredProcessData, setFilteredProcessData] = useState([])
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isCreateNewProcessButtonDisabled, setIsCreateNewProcessButtonDisabled] = useState(false)
  const [isCreateNewProcessButtonHidden, setIsCreateNewProcessButtonHidden] = useState(true)
  const [currencyForDashboardValues, setCurrencyForDashboard] = useState([])
  const [searchFields, setSearchFields] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [excelLoading, setExcelLoading] = useState(false)
  const [showFilterIcons, setShowFilterIcons] = useState(false)
  const [clearFilterInput, setClearFilterInput] = useState({})
  const [stickyRowTop, setStickyRowTop] = useState(0)
  const [totalProcessCreated, setTotalProcessCreated] = useState(0)
  const tableHeadRef = useRef(null)
  const tableRef = useRef(null)
  const [processDataForProcessTemplate, setProcessDataForProcessTemplate] = useState([])
  const [loadAllData, setLoadAllData] = useState(false)
  const [loadAllDataWarningDialog, setLoadAllDataWarningDialog] = useState(false)
  const [companyDetails, setCompanyDetails] = useState({})
  const [usersList, setUsersList] = useState([])
  const getAlignmentForType = (type) => {
    const rightTypes = ['date', 'currency', 'number', 'datetime']
    return rightTypes.includes(type) ? 'right' : 'left'
  }
  const {
    processTemplate,
    processData,
    fieldTemplatesAll,
    fieldTemplates,
    hiddenColumns,
    activityTemplatesAll,
    activityTemplates,
    hiddenActivityColumns,
  } = processDashBoardData
  const processTemplateId = useParams().process_template_id
  const isFiltersOn = Object.keys(searchFields)?.length > 0 ? true : false

  const LOAD_ALL_DATA_LIMIT = 200

  const { dashboardTittle, cardIcons } = useResponsiveTypography()
  const defaultTableHeaders = [
    { id: 1001, name: 'Reference Number', width: '7rem', data_structure: FIELD_TYPES.TEXT },
    { id: 1002, name: 'Status', width: '3rem', data_structure: FIELD_TYPES.LIST },
    { id: 1003, name: 'Process Initiated On', width: '6rem', data_structure: FIELD_TYPES.DATE },
    { id: 1004, name: 'Process Closed On', width: '6rem', data_structure: FIELD_TYPES.DATE },
    { id: 1005, name: 'Current Activity', width: '8rem', data_structure: FIELD_TYPES.LIST },
    { id: 1006, name: 'Current Assignee', width: '8rem', data_structure: FIELD_TYPES.LIST },
    { id: 1007, name: 'Activity Assigned On', width: '6rem', data_structure: FIELD_TYPES.DATE },
    {
      id: 1007,
      name: 'Time Taken (Work Days)',
      width: '7.5rem',
      data_structure: FIELD_TYPES.NUMBER,
    },
  ]

  const defaultActivityTableHeaders = [
    { id: 2001, name: 'Version', width: '7rem', data_structure: FIELD_TYPES.NUMBER },
    { id: 2002, name: 'Status', width: '3rem', data_structure: FIELD_TYPES.LIST },
    { id: 2003, name: 'Closed Date', width: '6rem', data_structure: FIELD_TYPES.DATE },
    { id: 2004, name: 'Assignee', width: '6rem', data_structure: FIELD_TYPES.LIST },
    { id: 2005, name: 'Work hours', width: '8rem', data_structure: FIELD_TYPES.NUMBER },
  ]
  const grayHeaderColor = '#f7f9ff'
  useEffect(() => {
    if (tableHeadRef.current) {
      setStickyRowTop(tableHeadRef.current.offsetHeight - 1)
    }
  }, [tableHeadRef, defaultTableHeaders, fieldTemplatesAll, activityTemplatesAll])

  const handleCreateNewProcess = async () => {
    setIsDialogOpen(false)
    setIsCreateNewProcessButtonDisabled(true)
    const toastErrorMsg = 'An error occurred while initiating the new process.'
    const toastSuccessMsg = 'New process initiated successfully.'
    try {
      const { process_id, activity_template_id } = (
        await axios.post(
          `${NODE_BASE_URL}/data-entry/process-data`,
          { process_template_id: processTemplateId },
          axiosOptions
        )
      ).data

      toast.success(toastSuccessMsg, TOAST_SETTINGS)
      setTimeout(
        () => navigate(`/process-data/${process_id}/${activity_template_id}`),
        REDIRECT_TIMER
      )
    } catch (err) {
      toast.error(toastErrorMsg, TOAST_SETTINGS_ERROR)
      setIsCreateNewProcessButtonDisabled(false)
    }
  }

  const getActivityData = (processReferenceNum, allProcessData, activityId, holidayList) => {
    const filteredActivityData = allProcessData
      .filter(
        (pd) =>
          pd.process_reference_num == processReferenceNum && pd.activity_template_id == activityId
      )
      .sort((a, b) => (a.id > b.id ? 1 : -1))
    if (filteredActivityData.length > 0) {
      const latestData = filteredActivityData[filteredActivityData.length - 1]
      let assigneeName = latestData.modified_by_user || ''
      // assigneeName = assigneeName?.replace(/\s*\(.*?\)\s*/g, '')

      const officeStartTime = 9.5 // 9:30 AM in decimal hours
      const officeEndTime = 18 // 6 PM in decimal hours
      const minutesInHour = 60

      const isHoliday = (date) => {
        const year = date.getFullYear()
        const month = date.getMonth() + 1 // JS months are 0-indexed
        const day = date.getDate()
        const holidays = holidayList.filter((holiday) => holiday.y === year && holiday.m === month)
        return holidays.some((holiday) => holiday.d.some((d) => d.day === day))
      }

      const getOfficeHoursInDay = (date) => {
        const dayOfWeek = date.getDay()
        if (dayOfWeek === 0 || dayOfWeek === 6 || isHoliday(date)) {
          return 0
        }
        return officeEndTime - officeStartTime
      }

      const calculateEffectiveMinutes = (startTime, endTime) => {
        const startDay = new Date(startTime)
        const endDay = new Date(endTime)

        if (startDay.toDateString() === endDay.toDateString()) {
          // Same day
          if (isHoliday(startDay)) return 0
          const startHour = Math.max(
            officeStartTime,
            startDay.getHours() + startDay.getMinutes() / minutesInHour
          )
          const endHour = Math.min(
            officeEndTime,
            endDay.getHours() + endDay.getMinutes() / minutesInHour
          )
          return Math.max(0, Math.floor((endHour - startHour) * minutesInHour))
        } else {
          // Different days
          let totalMinutes = 0

          // First day
          const firstDayStartHour = Math.max(
            officeStartTime,
            startDay.getHours() + startDay.getMinutes() / minutesInHour
          )
          totalMinutes += Math.max(
            0,
            Math.floor((officeEndTime - firstDayStartHour) * minutesInHour)
          )

          // Full days in between
          const nextDay = new Date(startDay)
          nextDay.setDate(nextDay.getDate() + 1)
          while (nextDay < endDay) {
            totalMinutes += Math.floor(getOfficeHoursInDay(nextDay) * minutesInHour)
            nextDay.setDate(nextDay.getDate() + 1)
          }

          // Last day
          const lastDayEndHour = Math.min(
            officeEndTime,
            endDay.getHours() + endDay.getMinutes() / minutesInHour
          )
          totalMinutes += Math.max(
            0,
            Math.floor((lastDayEndHour - officeStartTime) * minutesInHour)
          )

          return Math.max(0, totalMinutes)
        }
      }

      // Calculate total work minutes
      const totalWorkMinutes = filteredActivityData.reduce((total, activity) => {
        const startTime = new Date(activity.created_at)
        const endTime = new Date(activity.modified_at)
        return total + calculateEffectiveMinutes(startTime, endTime)
      }, 0)

      const totalWorkHours = (totalWorkMinutes / minutesInHour).toFixed(2)

      return {
        version: filteredActivityData[filteredActivityData.length - 1].version,
        status: filteredActivityData[filteredActivityData.length - 1].status,
        closedDate: filteredActivityData[filteredActivityData.length - 1].modified_at
          ? filteredActivityData[filteredActivityData.length - 1].modified_at
          : '',
        assignee: assigneeName,
        workHours: totalWorkHours,
      }
    } else {
      return {
        version: '',
        status: '',
        closedData: '',
        assignee: '',
        workHours: null,
      }
    }
  }

  /* search functionality implementation */
  useEffect(() => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current)
    }

    searchTimer.current = setTimeout(() => {
      let arr = []
      Object.keys(searchFields).forEach((sfKey, i) => {
        const index = Number(sfKey.split('_')[1])
        const filteredProcessData = processData?.filter((pd) => {
          const cell = pd[index + 1]
          if (cell) {
            // Check if it's a currency field and attach the currency symbol
            if (cell.fieldType === FIELD_TYPES.CURRENCY) {
              const cellCurrencyObject = currencyForDashboardValues.find(
                (currency) => currency.process_reference_num == cell.process_reference_num
              )
              return containsKeys(
                cell.value,
                searchFields[sfKey],
                cell.fieldType,
                cellCurrencyObject
              )
            } else {
              return containsKeys(cell.value, searchFields[sfKey], cell.fieldType)
            }
          }
          return false
        })
        arr[i] = filteredProcessData
      })

      let atLeastOneIsEmpty = false
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].length === 0) {
          atLeastOneIsEmpty = true
          break
        }
      }
      if (atLeastOneIsEmpty) {
        setFilteredProcessData([])
      } else {
        const ints = intersection(arr)
        setFilteredProcessData(ints)
      }
      searchTimer.current = null
    }, 200)
  }, [searchFields, processData, currencyForDashboardValues])

  //  getting data by processTemplateId
  useEffect(() => {
    if (processTemplateId != null && user) {
      ;(async () => {
        await getDataFromServer(LOAD_ALL_DATA_LIMIT)
      })()
    }
  }, [processTemplateId, user])

  const getDataFromServer = async (limit) => {
    setIsLoading(true)

    try {
      const processRelatedData = (
        await axios.get(
          `${NODE_BASE_URL}/process-dashboard/${processTemplateId}?limit=${limit}`,
          axiosOptions
        )
      ).data

      const processTemplateResult = processRelatedData.processTemplate
      const listDataForCompanyResult = processRelatedData.listData
      const usersAndTeamsDynamicList = processRelatedData.dynamicListData
      setUsersList(usersAndTeamsDynamicList?.usersList || [])
      let fieldTemplatesResult = processRelatedData.processDashboardFields
      const processDataForProcessTemplate = processRelatedData.processData
      const processInternalVisibility = processRelatedData.processInternalVisibility
      const isViewAllowed = processRelatedData.isViewAllowed
      const isInitiateAllowed = processRelatedData.isInitiationAllowed
      const currencyForDashboard = processRelatedData.nonDefaultCurrencies
      const activityTemplates = processRelatedData.activityTemplates
        .filter((activity) =>
          [ACTIVITY_TYPES.DATA_ENTRY, ACTIVITY_TYPES.REVIEW, ACTIVITY_TYPES.LONG_RUNNING].includes(
            activity.activity_type
          )
        )
        .map((activity) => ({ ...activity, is_hidden: false }))

      const holidayList = processRelatedData.holidays
      const totalProcessCreated = processRelatedData.totalProcessCreated
      setCurrencyForDashboard(currencyForDashboard)
      setCompanyDetails(processRelatedData.companyDetails)

      setIsCreateNewProcessButtonHidden(!isInitiateAllowed)
      setTotalProcessCreated(totalProcessCreated)

      if (!isViewAllowed) {
        navigate(`/process-dashboard/`)
      }
      let processDataObj = {}
      processDataForProcessTemplate.forEach((pdRow) => {
        for (const [key, value] of Object.entries(pdRow.data)) {
          // we don't need the table subfields here
          if (!key.includes('__')) {
            processDataObj[key + '~' + pdRow.process_reference_num] = value
          }
        }
      })

      let processDataArr = []
      // after the following loop, the index of processDataArr will be the process ref num
      for (const [key, value] of Object.entries(processDataObj)) {
        const [keyWithoutRefNum, processReferenceNum] = key.split('~')
        const index = parseInt(processReferenceNum)
        if (!processDataArr[index]) {
          processDataArr[index] = {}
        }
        processDataArr[index][keyWithoutRefNum] = value
      }
      let checkProcessDataIsVisibleForTheUser = (processData) => {
        let returnValue = true
        if (processInternalVisibility?.length > 0) {
          let currentUserTeams = user?.teams
          Object.keys(processData).forEach((key) => {
            let fieldId = key.split('__')[0].split('_')[1]
            processInternalVisibility?.forEach((piv) => {
              if (
                fieldId == piv?.is_private_field_template_id &&
                processData[key] == piv?.is_private_list_data_id
              ) {
                let allowedTeams =
                  processData[getFieldId(piv?.private_teams_list_field_template_id)]

                if (Array.isArray(allowedTeams)) {
                  returnValue = !allowedTeams.some((val) => currentUserTeams?.includes(val))
                } else {
                  returnValue = !currentUserTeams.includes(allowedTeams)
                }
              }
            })
          })
        }
        return returnValue
      }

      // now we make the internal object an array in the same order as the fields

      let processDataArr2 = []
      for (let i = 0; i < processDataArr.length; i++) {
        if (processDataArr[i] == null) {
          continue
        }

        if (!checkProcessDataIsVisibleForTheUser(processDataArr[i])) {
          continue
        }

        const processStatus = getProcessStatusByReferenceNum(i, processDataForProcessTemplate)

        setProcessDataForProcessTemplate(processDataForProcessTemplate)

        const processInitiatedAt = getProcessDashboardReportData(
          i,
          processDataForProcessTemplate,
          'initiatedAt'
        )

        const processClosedAt = getProcessDashboardReportData(
          i,
          processDataForProcessTemplate,
          'closedAt'
        )

        const currentTask = getProcessDashboardReportData(
          i,
          processDataForProcessTemplate,
          'currentTask'
        )
        const currentAssignee = getProcessDashboardReportData(
          i,
          processDataForProcessTemplate,
          'currentAssignee'
        )
        const TaskAssignedAt = getProcessDashboardReportData(
          i,
          processDataForProcessTemplate,
          'taskAssignedAt'
        )
        const calenderTime = getProcessDashboardReportData(
          i,
          processDataForProcessTemplate,
          'calenderTime'
        )

        let processDataRow = [
          //1: Process ref
          {
            value: processTemplateResult[0].prefix + '-' + i,
            fieldType: null,
            is_hidden: false,
            process_reference_num: i,
          },
          //2: Process status
          {
            value: processStatus,
            fieldType: null,
            is_hidden: false,
            process_reference_num: i,
          },
          //3: Process initiate at
          {
            value: processInitiatedAt,
            fieldType: 'date',
            is_hidden: false,
            process_reference_num: i,
          },
          //4 : Process Closed at
          {
            value: processClosedAt,
            fieldType: 'date',
            is_hidden: false,
            process_reference_num: i,
          },
          //5 : Current Task
          {
            value: currentTask,
            fieldType: 'text',
            is_hidden: false,
            process_reference_num: i,
          },
          //6 : Current Assignee
          {
            value: currentAssignee,
            fieldType: 'text',
            is_hidden: false,
            process_reference_num: i,
          },
          //7 : Task Assigned At
          {
            value: TaskAssignedAt,
            fieldType: 'date',
            is_hidden: false,
            process_reference_num: i,
          },
          {
            value: calenderTime,
            fieldType: 'number',
            is_hidden: false,
            process_reference_num: i,
          },
        ]

        const getListValue = (list, currentListId, is_hidden, id) => {
          const listData = list.find((it) => it.id == currentListId)
          processDataRow.push({
            value: listData?.value ? listData?.value : '',
            fieldType: FIELD_TYPES.LIST,
            is_hidden: is_hidden,
            id: id,
            process_reference_num: i,
          })
        }

        for (let j = 0; j < fieldTemplatesResult.length; j++) {
          if (fieldTemplatesResult[j].data_structure === FIELD_TYPES.LIST) {
            if (
              processDataArr[i]['f_' + fieldTemplatesResult[j].id] == DROPDOWN_DEFAULT_VALUE ||
              processDataArr[i]['f_' + fieldTemplatesResult[j].id] == undefined
            ) {
              processDataRow.push({
                value: '',
                fieldType: FIELD_TYPES.LIST,
                is_hidden: fieldTemplatesResult[j].is_hidden,
                id: fieldTemplatesResult[j].id,
                process_reference_num: i,
              })
            } else {
              if (fieldTemplatesResult[j].dynamic_field_type != null) {
                const meta = fieldTemplatesResult[j].dynamic_field_type
                if (meta?.type == 'teams') {
                  let teamsList = usersAndTeamsDynamicList.teamsList
                  getListValue(
                    teamsList,
                    processDataArr[i]['f_' + fieldTemplatesResult[j].id],
                    fieldTemplatesResult[j].is_hidden,
                    fieldTemplatesResult[j].id
                  )
                } else if (meta?.type == 'users') {
                  let usersList = usersAndTeamsDynamicList.usersList
                  getListValue(
                    usersList,
                    processDataArr[i]['f_' + fieldTemplatesResult[j].id],
                    fieldTemplatesResult[j].is_hidden,
                    fieldTemplatesResult[j].id
                  )
                } else {
                  console.error('Dynamic Field Implementation Pending for ' + meta?.type)
                }
              } else {
                getListValue(
                  listDataForCompanyResult,
                  processDataArr[i]['f_' + fieldTemplatesResult[j].id],
                  fieldTemplatesResult[j].is_hidden,
                  fieldTemplatesResult[j].id
                )
              }
            }
          } else if (fieldTemplatesResult[j].data_structure === FIELD_TYPES.LIST_MULTI) {
            if (
              processDataArr[i]['f_' + fieldTemplatesResult[j].id] == DROPDOWN_DEFAULT_VALUE ||
              processDataArr[i]['f_' + fieldTemplatesResult[j].id] == undefined
            ) {
              processDataRow.push({
                value: '',
                fieldType: FIELD_TYPES.LIST_MULTI,
                is_hidden: fieldTemplatesResult[j].is_hidden,
                id: fieldTemplatesResult[j].id,
                process_reference_num: i,
              })
            } else {
              if (fieldTemplatesResult[j].dynamic_field_type != null) {
                const meta = fieldTemplatesResult[j].dynamic_field_type
                if (meta?.type == 'teams') {
                  let teamsList = usersAndTeamsDynamicList.teamsList
                  if (Array.isArray(processDataArr[i]['f_' + fieldTemplatesResult[j].id])) {
                    let val = []
                    processDataArr[i]['f_' + fieldTemplatesResult[j].id].forEach((ele) => {
                      const listData = teamsList.find((it) => it.id == ele)
                      if (listData) {
                        val.push(listData.value)
                      }
                    })
                    val = val?.map((data, i) => <p key={i}>{data}</p>)
                    processDataRow.push({
                      value: val,
                      fieldType: FIELD_TYPES.LIST_MULTI,
                      is_hidden: fieldTemplatesResult[j].is_hidden,
                      id: fieldTemplatesResult[j].id,
                      process_reference_num: i,
                    })
                  }
                } else if (meta?.type == 'users') {
                  let usersList = usersAndTeamsDynamicList.usersList
                  if (Array.isArray(processDataArr[i]['f_' + fieldTemplatesResult[j].id])) {
                    let val = []
                    processDataArr[i]['f_' + fieldTemplatesResult[j].id].forEach((ele) => {
                      const listData = usersList.find((it) => it.id == ele)
                      if (listData) {
                        const nameOnly = listData.value.split('(')[0].trim()
                        val.push(nameOnly)
                      }
                    })
                    val = val?.map((data, i) => <p key={i}>{data}</p>)
                    processDataRow.push({
                      value: val,
                      fieldType: FIELD_TYPES.LIST_MULTI,
                      is_hidden: fieldTemplatesResult[j].is_hidden,
                      id: fieldTemplatesResult[j].id,
                      process_reference_num: i,
                    })
                  }
                } else {
                  console.error('Dynamic Field Implementation Pending for ' + meta?.type)
                }
              } else {
                if (Array.isArray(processDataArr[i]['f_' + fieldTemplatesResult[j].id])) {
                  let val = []
                  processDataArr[i]['f_' + fieldTemplatesResult[j].id].forEach((ele) => {
                    const res = listDataForCompanyResult.find((lst) => lst.id == ele)
                    if (res) {
                      val.push(res?.value)
                    }
                  })
                  val = val?.map((data, i) => <p key={i}>{data}</p>)
                  if (val) {
                    processDataRow.push({
                      value: val,
                      fieldType: FIELD_TYPES.LIST_MULTI,
                      is_hidden: fieldTemplatesResult[j].is_hidden,
                      id: fieldTemplatesResult[j].id,
                      process_reference_num: i,
                    })
                  }
                } else {
                  processDataRow.push({
                    value: '',
                    fieldType: FIELD_TYPES.LIST_MULTI,
                    is_hidden: fieldTemplatesResult[j].is_hidden,
                    id: fieldTemplatesResult[j].id,
                    process_reference_num: i,
                  })
                }
              }
            }
          } else if (fieldTemplatesResult[j].data_structure === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
            let value1 = processDataArr[i]['f_' + fieldTemplatesResult[j].id]
            if (!value1) {
              processDataRow.push({
                value: [],
                fieldType: fieldTemplatesResult[j].data_structure,
                is_hidden: fieldTemplatesResult[j].is_hidden,
                id: fieldTemplatesResult[j].id,
                process_reference_num: i,
              })
            } else {
              processDataRow.push({
                value: Array.isArray(value1) ? value1 : [],
                fieldType: fieldTemplatesResult[j].data_structure,
                is_hidden: fieldTemplatesResult[j].is_hidden,
                id: fieldTemplatesResult[j].id,
                process_reference_num: i,
              })
            }
          } else {
            let value1 = processDataArr[i]['f_' + fieldTemplatesResult[j].id]
            if (!value1) {
              processDataRow.push({
                value: '',
                fieldType: fieldTemplatesResult[j].data_structure,
                is_hidden: fieldTemplatesResult[j].is_hidden,
                id: fieldTemplatesResult[j].id,
                process_reference_num: i,
              })
            } else {
              processDataRow.push({
                value: value1.toString(),
                fieldType: fieldTemplatesResult[j].data_structure,
                is_hidden: fieldTemplatesResult[j].is_hidden,
                id: fieldTemplatesResult[j].id,
                process_reference_num: i,
              })
            }
          }
        }

        for (let activity of activityTemplates) {
          let activityData = getActivityData(
            i,
            processDataForProcessTemplate,
            activity.id,
            holidayList
          )
          // version
          processDataRow.push({
            value: activityData['version'],
            id: activity.id,
            fieldType: 'number',
            is_hidden: false,
            process_reference_num: i,
            is_Activity: true,
          })
          // status
          processDataRow.push({
            value: activityData['status'],
            id: activity.id,
            fieldType: 'list',
            is_hidden: false,
            process_reference_num: i,
            is_Activity: true,
          })
          // closed date
          processDataRow.push({
            value: activityData['closedDate'],
            id: activity.id,
            fieldType: 'date',
            is_hidden: false,
            process_reference_num: i,
            is_Activity: true,
          })
          // assignee
          processDataRow.push({
            value: activityData['assignee'],
            id: activity.id,
            fieldType: 'list',
            is_hidden: false,
            process_reference_num: i,
            is_Activity: true,
          })
          // working hours
          processDataRow.push({
            value: activityData['workHours'],
            id: activity.id,
            fieldType: 'number',
            is_hidden: false,
            process_reference_num: i,
            is_Activity: true,
          })
        }
        processDataArr2.push(processDataRow)
      }
      processDataArr2 = processDataArr2.reverse()
      for (let pdRow of processDataArr2) {
        pdRow.unshift({
          id: pdRow[0].id,
          value: pdRow[0].value.toString().split('-')[1],
          fieldType: null,
        })
      }

      const userProcessDashboardConfigs = processRelatedData.userProcessDashboardConfigs

      const hiddenFieldIds = userProcessDashboardConfigs?.hidden_field_ids

      const visibleColumnFields = fieldTemplatesResult?.filter(
        (it) => !hiddenFieldIds?.includes(it.id)
      )

      const visibleActivityIds = userProcessDashboardConfigs?.visible_activity_template_ids

      const visibleColumnActivity = activityTemplates?.filter((it) =>
        visibleActivityIds?.includes(it.id)
      )

      // actually hidden activity
      const hiddenActivityIds = activityTemplates
        .map((it) => it.id)
        .filter((it) => !visibleActivityIds?.includes(it))

      setProcessDashBoardData({
        processTemplate: processTemplateResult[0],
        processData: processDataArr2,
        fieldTemplatesAll: fieldTemplatesResult,
        fieldTemplates: visibleColumnFields,
        hiddenColumns: hiddenFieldIds,
        activityTemplatesAll: activityTemplates,
        activityTemplates: visibleColumnActivity,
        hiddenActivityColumns: hiddenActivityIds,
      })
    } catch (error) {
      console.error('Promise.all Error', error)
    }

    setIsLoading(false)
  }

  const handleSearchFieldsChange = (e) => {
    setSearchFields({
      ...searchFields,
      [e.target.name]: e.target.value,
    })
  }

  const openDialog = () => {
    setIsDialogOpen(true)
  }

  const exportToExcel = async () => {
    // First row of headers (Primary Headers)
    let columnIndex = 0
    let processMetaDataFrom = columnIndex
    let processMetaDataTo = processMetaDataFrom + (defaultTableHeaders.length - 1)

    columnIndex = processMetaDataTo
    let processDataFrom = columnIndex + 1
    let processDataTo = processDataFrom + (fieldTemplates.length - 1)

    columnIndex = processDataTo
    const primaryHeaders = [
      // Process Metadata
      {
        name: 'Process Metadata',
        from: `${EXCEL_COLUMNS[processMetaDataFrom]}1`,
        to: `${EXCEL_COLUMNS[processMetaDataTo]}1`,
      },
      // Process Data
      {
        name: 'Process Data',
        from: `${EXCEL_COLUMNS[processDataFrom]}1`,
        to: `${EXCEL_COLUMNS[processDataTo]}1`,
      },
    ]

    // Adding headers for activityTemplates based on defaultActivityTableHeaders
    activityTemplates.forEach((activity, index) => {
      const activityFrom = columnIndex + 1
      const activityTo = activityFrom + defaultActivityTableHeaders.length - 1

      primaryHeaders.push({
        name: `Timeline : ${activity.activity_template_name}`,
        from: `${EXCEL_COLUMNS[activityFrom]}1`,
        to: `${EXCEL_COLUMNS[activityTo]}1`,
      })

      columnIndex = activityTo
    })

    // Second row of headers (Secondary Headers)
    const secondaryHeaders = [
      ...defaultTableHeaders.map((it) => it.name),
      ...(fieldTemplates && fieldTemplates.length > 0
        ? fieldTemplates.map((ft) => ft.field_template_name)
        : []),
      ...(activityTemplates && activityTemplates.length > 0
        ? activityTemplates.flatMap(() => defaultActivityTableHeaders.map((header) => header.name))
        : []),
    ]

    setExcelLoading(true)

    // Create the primary header row with styles
    const header = {
      [EXCEL_COLUMNS[0]]: {
        v: '',
      },
    }

    // Create the secondary header row
    const secondaryHeader = secondaryHeaders.reduce((acc, cur, index) => {
      return {
        ...acc,
        [EXCEL_COLUMNS[index]]: {
          v: cur,
          s: {
            bold: true,
          },
        },
      }
    }, {})

    let allRowsData = [header, secondaryHeader]

    // Helper function to get the actual value based on field type
    const getActualValue = (fieldType, value, currencyCode) => {
      if (
        (fieldType === FIELD_TYPES.DATE || fieldType === FIELD_TYPES.DATETIME) &&
        value?.length > 0
      ) {
        const excelDate = moment(value).toDate()

        return {
          v: excelDate,
          t: 'd',
          numFmt: fieldType === FIELD_TYPES.DATE ? 'mm/dd/yyyy' : 'mm/dd/yyyy hh:mm AM/PM',
        }
      } else if (fieldType === FIELD_TYPES.CURRENCY) {
        const parsedValue = parseFloat(value)
        if (isNaN(parsedValue)) return { v: null }

        const currencySymbol = CURRENCY_COUNTRY_CODE[currencyCode] || ''
        const numFmt = CURRENCY_COUNTRY_CODE[currencyCode]
          ? `"${currencySymbol}" #,##0.00`
          : '"₹" #,##0.00'

        return { v: parsedValue, numFmt }
      } else if (fieldType === FIELD_TYPES.NUMBER) {
        const parsedValue = parseFloat(value)
        return { v: isNaN(parsedValue) ? null : parsedValue }
      } else if (fieldType === FIELD_TYPES.TIMESTAMPED_BIGTEXT) {
        if (Array.isArray(value) && value.length > 0) {
          const formattedValue = value
            .map((entry) => {
              const username = entry.user_id
                ? usersList
                    ?.find((u) => u.id === entry.user_id)
                    ?.value?.replace(/\s*\([^)]*\)\s*/g, '')
                    .trim()
                : null
              return `${entry.timestamp}: ${entry.text}${username ? ` - ${username}` : ''}`
            })
            .join('\n\n')

          return { v: formattedValue }
        }
        return { v: '' }
      } else {
        return { v: value }
      }
    }

    processData.forEach((row) => {
      const filteredRow = row.filter((item) => {
        if (item.is_Activity) {
          return !hiddenActivityColumns?.includes(item.id)
        } else {
          return !hiddenColumns?.includes(item.id)
        }
      })
      const keys = Object.keys(filteredRow)
      const rest = keys.slice(1) // Exclude the first key
      const data = rest.reduce((acc, key, index) => {
        const currencyObj = currencyForDashboardValues.find(
          (currency) => currency.process_reference_num === filteredRow[key].process_reference_num
        )

        const currencyCode = currencyObj ? currencyObj.currency_code : null

        return {
          ...acc,
          [EXCEL_COLUMNS[index]]: getActualValue(
            filteredRow[key].fieldType,
            filteredRow[key].value,
            currencyCode
          ),
        }
      }, [])
      allRowsData.push(data)
    })

    // Set the filename for the Excel file
    const filename = `${processTemplate?.process_template_name}-(${moment(new Date()).format(
      'DD MMM YYYY'
    )})`

    // Download the Excel file
    downloadExcel(
      [
        {
          name: 'Sheet1',
          data: allRowsData,
        },
      ],
      filename,
      primaryHeaders
    )

    setExcelLoading(false)
  }

  const handleSetHiddenColumns = async (hiddenFieldIds, hiddenActivityIds) => {
    if (user) {
      await saveUserProcessDashBoardConfigs(user, hiddenFieldIds, hiddenActivityIds)
    }
  }

  const saveUserProcessDashBoardConfigs = async (user, hiddenFieldIds, hiddenActivityIds) => {
    try {
      const visibleActivityIds = processDashBoardData.activityTemplatesAll
        ?.map((it) => it.id)
        ?.filter((it) => !hiddenActivityIds?.includes(it))
      updateFieldTemplate(hiddenFieldIds)
      updateActivityTemplate(hiddenActivityIds)
      await userConfig.saveProcessDashBoardConfig(
        user,
        hiddenFieldIds,
        processTemplateId,
        visibleActivityIds
      )
    } catch (error) {
      console.error(error)
    }
  }

  const updateFieldTemplate = (hiddenFieldIds = []) => {
    const newFieldTemplate = fieldTemplatesAll.filter((it) => !hiddenFieldIds.includes(it.id))
    setProcessDashBoardData((state) => ({
      ...state,
      fieldTemplates: newFieldTemplate,
      hiddenColumns: hiddenFieldIds,
    }))
  }

  const updateActivityTemplate = (hiddenActivityIds = []) => {
    const newActivityTemplate = activityTemplatesAll.filter(
      (it) => !hiddenActivityIds.includes(it.id)
    )
    setProcessDashBoardData((state) => ({
      ...state,
      activityTemplates: newActivityTemplate,
      hiddenActivityColumns: hiddenActivityIds,
    }))
  }

  const handleSetHiddenActivityColumns = async (hiddenActivityIds = []) => {
    if (user) {
      await saveUserProcessDashBoardConfigs(user, hiddenColumns, hiddenActivityIds)
    }
  }

  const handleShowFilters = () => {
    setShowFilterIcons((prevState) => !prevState)
    if (showFilterIcons) {
      setSearchFields({})
      setFilteredProcessData(processData)
    } else {
      if (
        !loadAllData &&
        totalProcessCreated >= processData.length &&
        totalProcessCreated > LOAD_ALL_DATA_LIMIT
      ) {
        setLoadAllDataWarningDialog(true)
      }
    }
  }
  const handleLoadAllData = async () => {
    setLoadAllDataWarningDialog(false)
    await getDataFromServer(0)
    setLoadAllData(true)
  }

  const renderFilterComponent = (index, dataStructure) => {
    if (!showFilterIcons) return null
    switch (dataStructure) {
      case FIELD_TYPES.BIGTEXT:
        return (
          <ClearableTextField
            id={'sf_' + index}
            name={'sf_' + index}
            variant="outlined"
            color="primary"
            size="small"
            onChange={handleSearchFieldsChange}
            fullWidth
            value={searchFields['sf_' + index] || ''}
            sx={{
              '& .MuiInputBase-root': {
                height: 25,
              },
            }}
            clear={clearFilterInput[index] || false}
          />
        )
      case FIELD_TYPES.TIMESTAMPED_BIGTEXT:
        return (
          <TextField
            id={'sf_' + index}
            name={'sf_' + index}
            variant="outlined"
            color="primary"
            size="small"
            onChange={handleSearchFieldsChange}
            fullWidth
            value={searchFields['sf_' + index] || ''}
            sx={{
              '& .MuiInputBase-root': {
                height: 25,
              },
            }}
            clear={clearFilterInput[index] || false}
          />
        )
      case FIELD_TYPES.TEXT:
        return (
          <ClearableTextField
            id={'sf_' + index}
            name={'sf_' + index}
            variant="outlined"
            color="primary"
            size="small"
            value={searchFields['sf_' + index] || ''}
            onChange={handleSearchFieldsChange}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                height: 25,
              },
            }}
            clear={clearFilterInput[index] || false}
          />
        )
      case FIELD_TYPES.DATE:
        return (
          <DateRangePickerComponent
            id={'sf_' + index}
            onChange={(range) => {
              setSearchFields((prevState) => ({
                ...prevState,
                ['sf_' + index]: range,
              }))
            }}
            clear={clearFilterInput[index] || false}
            value={searchFields['sf_' + index]}
          />
        )
      case FIELD_TYPES.DATETIME:
        return (
          <DateTimeRangePickerComponent
            id={'sf_' + index}
            onChange={(range) => {
              setSearchFields((prevState) => ({
                ...prevState,
                ['sf_' + index]: range,
              }))
            }}
            clear={clearFilterInput[index] || false}
          />
        )

      case FIELD_TYPES.LIST_MULTI:
      case FIELD_TYPES.LIST:
        const activeData = Object.values(searchFields).some((it) => it?.length > 0)
          ? filteredProcessData
          : processData

        const options = processData
          .map((pd) => pd[index + 1]?.value)
          .filter(Boolean)
          .reduce((acc, cur) => {
            const activeCount = activeData.filter((ad) => ad[index + 1]?.value === cur).length

            const valueObj = acc.find((it) => it.value === cur)
            if (valueObj) {
              return acc.map((it) =>
                it.value == cur
                  ? {
                      ...valueObj,
                      count: activeCount,
                    }
                  : it
              )
            } else {
              return [
                ...acc,
                {
                  value: cur,
                  count: activeCount,
                },
              ]
            }
          }, [])

        return (
          <ListDropdown
            options={options}
            onApply={(value) => {
              const selectedValues = value.map((item) => item.value)

              setSearchFields((prevState) => {
                const newState = { ...prevState }
                if (selectedValues.length > 0) {
                  newState['sf_' + index] = selectedValues
                } else {
                  delete newState['sf_' + index]
                }
                return newState
              })

              const newIsFiltersOn =
                selectedValues.length > 0 || Object.keys(searchFields).length > 0
              setFilteredProcessData(
                newIsFiltersOn
                  ? processData.filter((pd) => {
                      return Object.keys(searchFields).every((key) => {
                        const fieldIndex = key.split('_')[1]
                        return searchFields[key].includes(pd[fieldIndex + 1]?.value)
                      })
                    })
                  : processData
              )
              setClearFilterInput((prev) => ({ ...prev, [index]: false }))
            }}
            clear={clearFilterInput[index] || false}
            value={searchFields['sf_' + index]}
          />
        )

      case FIELD_TYPES.NUMBER:
        return (
          <NumberRangeComponent
            id={'sf_' + index}
            onChange={(range) => {
              const [initial, last] = range
              setSearchFields((prevState) => {
                const newState = { ...prevState }
                if (initial === null && last === null) {
                  delete newState['sf_' + index]
                } else {
                  newState['sf_' + index] = range
                }
                return newState
              })

              const updatedFilteredData = processData.filter((pd) => {
                const value = pd[index + 1]?.value
                return (initial === null || value >= initial) && (last === null || value <= last)
              })

              setFilteredProcessData(updatedFilteredData)
            }}
            clear={clearFilterInput[index] || false}
            value={searchFields['sf_' + index]}
          />
        )
      case FIELD_TYPES.CURRENCY:
        return (
          <CurrencyRangeComponent
            id={'sf_' + index}
            onChange={(filter) => {
              setSearchFields((prevState) => ({
                ...prevState,
                ['sf_' + index]: filter,
              }))
            }}
            clear={clearFilterInput[index] || false}
            value={searchFields['sf_' + index]}
          />
        )

      default:
        return null
    }
  }

  const isFilterApplied = (index) => {
    return Boolean(searchFields[`sf_${index}`])
  }

  const onClearFilter = (index) => {
    setClearFilterInput((prevState) => ({
      ...prevState,
      [index]: true,
    }))
    setSearchFields((prevState) => {
      const updatedFields = { ...prevState }
      delete updatedFields['sf_' + index]
      return updatedFields
    })

    setFilteredProcessData(processData)

    setTimeout(() => {
      setClearFilterInput((prev) => ({ ...prev, [index]: false }))
    }, 0)
  }

  const activityNamesArray = activityTemplates.map(
    (template) => `TimeLine: ${template.activity_template_name}`
  )

  const prevScrollY = useRef(0)
  const handleScroll = () => {
    const table = tableRef.current

    if (table.scrollTop > prevScrollY.current) {
      if (
        table.scrollTop + table.clientHeight >= table.scrollHeight - 10 &&
        !loadAllData &&
        totalProcessCreated >= processData.length &&
        totalProcessCreated > LOAD_ALL_DATA_LIMIT
      ) {
        setLoadAllDataWarningDialog(true)
      }
    }
    prevScrollY.current = table.scrollTop
  }

  return (
    <>
      <div className="process-dashbaord" style={{ marginTop: '-10px' }}>
        <div
          className="process-dashbaord"
          style={{ padding: '0px 5px 20px 0px', width: '100%', marginLeft: '0px' }}
        >
          {isLoading ? null : (
            <div
              className="process-group-icon"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <div style={{ display: 'flex' }}>
                    <Typography
                      className="textPrimary fontWeight700 "
                      style={{ fontSize: dashboardTittle, fontWeight: 'bold' }}
                    >
                      {' '}
                      {processTemplate.process_template_name}{' '}
                    </Typography>
                  </div>
                </Box>

                <Box
                  className="processdata-group-icon"
                  style={{
                    fontSize: '14px',
                  }}
                >
                  {
                    <div style={cardIcons}>
                      <div hidden={isCreateNewProcessButtonHidden}>
                        <Tooltip title="Initiate new process workflow">
                          <IconButton
                            disabled={isCreateNewProcessButtonDisabled}
                            onClick={openDialog}
                            size="large"
                            style={{ marginLeft: '5px', padding: '2px' }}
                          >
                            <AddOutlinedIcon sx={{ fontSize: '20px', color: '#41464a' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                      <Tooltip title="Download Process Data in Excel">
                        <IconButton
                          onClick={exportToExcel}
                          size="large"
                          style={{ margin: '0px  5px 0px 0px', padding: '2px' }}
                        >
                          {excelLoading ? (
                            <CircularProgress sx={{ fontSize: '20px', color: '#41464a' }} />
                          ) : (
                            <FileDownloadOutlinedIcon sx={{ fontSize: '20px', color: '#41464a' }} />
                          )}
                        </IconButton>
                      </Tooltip>

                      <TableSetting
                        columns={getFieldForSetting(fieldTemplatesAll)}
                        hiddenColumns={processDashBoardData.hiddenColumns}
                        setHiddenColumns={(it) =>
                          handleSetHiddenColumns(it, processDashBoardData.hiddenActivityColumns)
                        }
                        activityColumns={getColumnForSetting(activityTemplatesAll)}
                        hiddenActivityColumns={processDashBoardData.hiddenActivityColumns}
                        setHiddenActivityColumns={handleSetHiddenActivityColumns}
                        color="primary"
                      />

                      <Tooltip title={showFilterIcons ? 'Clear All Filters' : 'Enable Filter'}>
                        <IconButton
                          size="large"
                          onClick={handleShowFilters}
                          style={{ marginLeft: '5px', padding: '2px' }}
                        >
                          {showFilterIcons ? (
                            <FilterAltOffOutlinedIcon sx={{ fontSize: '20px', color: '#41464a' }} />
                          ) : (
                            <FilterAltOutlinedIcon sx={{ fontSize: '20px', color: '#41464a' }} />
                          )}
                        </IconButton>
                      </Tooltip>
                    </div>
                  }
                </Box>
              </Box>
              <Typography
                className="fontWeight600 "
                style={{ fontSize: '12px', textTransform: 'capitalize', color: '#41464a' }}
              >
                {' '}
                <TableRowsOutlinedIcon
                  className="mr-2"
                  style={{ fontSize: '18px', color: '#41464a' }}
                />
                {isFiltersOn
                  ? `${filteredProcessData.length} row(s)`
                  : `${processData.length} row(s)`}
              </Typography>
            </div>
          )}
        </div>

        {isDialogOpen && (
          <ConfirmationBox
            title={confirmationText}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            onYes={handleCreateNewProcess}
          />
        )}

        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '70vh',
            }}
          >
            <CircularProgress color="primary" size={50} />
          </div>
        ) : (
          <>
            <TableContainer
              sx={{
                width: '100%',
                overflowX: 'auto',
                maxHeight: '75vh',
              }}
              component={Paper}
              ref={tableRef}
              onScroll={handleScroll}
            >
              <Table className="responsiveTable" stickyHeader aria-label="simple table">
                <TableHead ref={tableHeadRef}>
                  <TableRow sx={{ position: 'sticky', zIndex: 2, top: 0 }}>
                    <TableCell
                      className=""
                      align="center"
                      sx={{ backgroundColor: grayHeaderColor }}
                      colSpan={defaultTableHeaders.length + 1}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 'bolder',
                          letterSpacing: '1px',
                          fontSize: '16px',
                          color: '#6c47e4',
                        }}
                      >
                        Process MetaData
                      </Typography>
                    </TableCell>

                    {fieldTemplates?.length > 0 && (
                      <TableCell
                        className=""
                        align="center"
                        sx={{
                          backgroundColor: grayHeaderColor,
                          fontWeight: 'bolder',
                          letterSpacing: '4px',
                          fontSize: '16px',
                        }}
                        colSpan={fieldTemplates.length}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 'bolder',
                            letterSpacing: '1px',
                            fontSize: '16px',
                            color: '#6c47e4',
                          }}
                        >
                          Process Data
                        </Typography>
                      </TableCell>
                    )}
                    {activityNamesArray.map((name, index) => (
                      <TableCell
                        className=""
                        key={index}
                        align="center"
                        sx={{ backgroundColor: grayHeaderColor }}
                        colSpan={defaultActivityTableHeaders.length}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 'bolder',
                            letterSpacing: '4px',
                            fontSize: '16px',
                            color: '#6c47e4',
                          }}
                        >
                          {name}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow sx={{ position: 'sticky', zIndex: 2, top: 28 }}>
                    <TableCell className="" align="left" sx={{ backgroundColor: grayHeaderColor }}>
                      <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                        Info
                      </Typography>
                    </TableCell>

                    {defaultTableHeaders.map((header, i) => (
                      <TableCell
                        className=""
                        key={i}
                        align="center"
                        sx={{ minWidth: header.width, backgroundColor: grayHeaderColor }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="center">
                          <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                            {header.name}
                          </Typography>

                          {showFilterIcons && (
                            <Tooltip
                              title={isFilterApplied(i) ? 'Filter Applied' : 'Enable Filter'}
                            >
                              <IconButton
                                size="small"
                                onClick={() => {
                                  if (isFilterApplied(i)) {
                                    onClearFilter(i)
                                  }
                                }}
                              >
                                {isFilterApplied(i) ? (
                                  <FilterAltOffOutlinedIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                  <FilterAltOutlinedIcon sx={{ fontSize: '18px' }} />
                                )}
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>
                    ))}

                    {fieldTemplatesAll?.length > 0 &&
                      fieldTemplatesAll.map(
                        (f, i) =>
                          !f?.is_hidden &&
                          !hiddenColumns?.includes(f.id) && (
                            <TableCell
                              className=""
                              id={i + defaultTableHeaders.length}
                              key={i + defaultTableHeaders.length}
                              align="center"
                              sx={{
                                minWidth: `${f.field_width_in_rem_for_process_dashboard}rem`,
                                backgroundColor: grayHeaderColor,
                              }}
                            >
                              <Box display="flex" alignItems="center" justifyContent="center">
                                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                                  {f?.field_template_name}
                                </Typography>

                                {showFilterIcons && (
                                  <Tooltip
                                    title={
                                      isFilterApplied(i + defaultTableHeaders.length)
                                        ? 'Filter Applied'
                                        : 'Enable Filter'
                                    }
                                  >
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        if (isFilterApplied(i + defaultTableHeaders.length)) {
                                          onClearFilter(i + defaultTableHeaders.length)
                                        }
                                      }}
                                    >
                                      {isFilterApplied(i + defaultTableHeaders.length) ? (
                                        <FilterAltOffOutlinedIcon sx={{ fontSize: '18px' }} />
                                      ) : (
                                        <FilterAltOutlinedIcon sx={{ fontSize: '18px' }} />
                                      )}
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </Box>
                            </TableCell>
                          )
                      )}

                    {activityTemplatesAll.map(
                      (data, index) =>
                        !hiddenActivityColumns?.includes(data.id) &&
                        defaultActivityTableHeaders.map((header, i) => (
                          <TableCell
                            className=""
                            key={`${index}-${i}`}
                            align={getAlignmentForType(header.data_structure)} // date currency time number alignment
                            sx={{ minWidth: header.width, backgroundColor: grayHeaderColor }}
                          >
                            <Box display="flex" alignItems="center" justifyContent="center">
                              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                                {header.name}
                              </Typography>

                              {showFilterIcons && (
                                <Tooltip
                                  title={
                                    isFilterApplied(
                                      i +
                                        defaultTableHeaders.length +
                                        fieldTemplatesAll.length +
                                        index * defaultActivityTableHeaders.length
                                    )
                                      ? 'Filter Applied'
                                      : 'Enable Filter'
                                  }
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      if (
                                        isFilterApplied(
                                          i +
                                            defaultTableHeaders.length +
                                            fieldTemplatesAll.length +
                                            index * defaultActivityTableHeaders.length
                                        )
                                      ) {
                                        onClearFilter(
                                          i +
                                            defaultTableHeaders.length +
                                            fieldTemplatesAll.length +
                                            index * defaultActivityTableHeaders.length
                                        )
                                      }
                                    }}
                                  >
                                    {isFilterApplied(
                                      i +
                                        defaultTableHeaders.length +
                                        fieldTemplatesAll.length +
                                        index * defaultActivityTableHeaders.length
                                    ) ? (
                                      <FilterAltOffOutlinedIcon sx={{ fontSize: '18px' }} />
                                    ) : (
                                      <FilterAltOutlinedIcon sx={{ fontSize: '18px' }} />
                                    )}
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        ))
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {showFilterIcons && (
                    <TableRow
                      style={{
                        position: 'sticky',
                        top: showFilterIcons ? stickyRowTop : stickyRowTop,
                        backgroundColor: '#fff',
                        zIndex: 2,
                        top: '82px',
                      }}
                    >
                      <TableCell style={{ padding: '8px' }}></TableCell>

                      {defaultTableHeaders.map((header, index) => (
                        <TableCell key={index} style={{ padding: '8px' }}>
                          {renderFilterComponent(index, header.data_structure)}
                        </TableCell>
                      ))}

                      {fieldTemplatesAll?.length > 0 &&
                        fieldTemplatesAll.map(
                          (f, i) =>
                            !f.is_hidden &&
                            !hiddenColumns?.includes(f.id) && (
                              <TableCell
                                id={'sf_' + (i + defaultTableHeaders.length)}
                                key={i + defaultTableHeaders.length}
                                style={{ padding: '8px' }}
                              >
                                {renderFilterComponent(
                                  i + defaultTableHeaders.length,
                                  f.data_structure
                                )}
                              </TableCell>
                            )
                        )}

                      {activityTemplatesAll?.length > 0 &&
                        activityTemplatesAll.map(
                          (data, index) =>
                            !hiddenActivityColumns?.includes(data.id) &&
                            defaultActivityTableHeaders.map((header, i) => (
                              <TableCell
                                key={
                                  i +
                                  defaultTableHeaders.length +
                                  fieldTemplatesAll.length +
                                  index * defaultActivityTableHeaders.length
                                }
                                align={getAlignmentForType(header.data_structure)} // 👈 currency, date time number align right side
                                style={{ padding: '8px' }}
                              >
                                {renderFilterComponent(
                                  i +
                                    defaultTableHeaders.length +
                                    fieldTemplatesAll.length +
                                    index * defaultActivityTableHeaders.length,
                                  header.data_structure
                                )}
                              </TableCell>
                            ))
                        )}
                    </TableRow>
                  )}

                  {isFiltersOn ? (
                    <ProcessDashboardValues
                      processData={filteredProcessData}
                      process_template_id={processTemplate.id}
                      hiddenColumns={hiddenColumns}
                      currencyForDashboardValues={currencyForDashboardValues}
                      hiddenActivityColumns={hiddenActivityColumns}
                      processTemplates={processTemplate}
                      processDataForProcessTemplate={processDataForProcessTemplate}
                      companyDetails={companyDetails}
                      usersList={usersList}
                    />
                  ) : (
                    <ProcessDashboardValues
                      processData={processData}
                      process_template_id={processTemplate.id}
                      hiddenColumns={hiddenColumns}
                      currencyForDashboardValues={currencyForDashboardValues}
                      hiddenActivityColumns={hiddenActivityColumns}
                      processTemplates={processTemplate}
                      processDataForProcessTemplate={processDataForProcessTemplate}
                      companyDetails={companyDetails}
                      usersList={usersList}
                    />
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        {loadAllDataWarningDialog && (
          <ConfirmationBox
            isDialogOpen={loadAllDataWarningDialog}
            setIsDialogOpen={setLoadAllDataWarningDialog}
            title={'Load all data? This could take a while.'}
            onYes={handleLoadAllData}
          />
        )}
      </div>
    </>
  )
}
